import {
  Route as AuthorizedRoute,
  Routes,
  Navigate,
  Outlet,
} from "react-router-dom";

/*Component Import*/
import Homepage from "./Homepage";
import Dashboard from "./Dashboard";
import Programs from "./Programs";
import AddProgram from "./AddProgram";
import ProgramStructure from "./ProgramStructure";
import TendersV2 from "./TendersV2";
import TenderDetails from "./TenderDetails";
import AddTender from "./AddTender";
import EditProgram from "./EditProgram";
import UserRolesAuthorisation from "./UserRolesAuthorisation";
import AddUserRolesAuthorisation from "./AddUserRolesAuthorisation";
import AddUserFakultetaRolesAuthorisation from "./AddUserFakultetaRolesAuthorisation";
import EditUserRolesAuthorisation from "./EditUserRolesAuthorisation";
import EditUserFakultetaRolesAuthorisation from "./EditUserFakultetaRolesAuthorisation";
import Revision from "./Revision";
import CodeList from "./CodeList";
import ProjectPartnersV2 from "./ProjectPartnersV2";
import AddProjectPartner from "./AddProjectPartner";
import ProjectPartnerDetails from "./ProjectPartnerDetails";
import AddOrgUnit from "./AddOrgUnit";
import EditOrgUnit from "./EditOrgUnit";
import AddProject from "./AddProject";
import ProjectsV2 from "./ProjectsV2";
import Reports from "./Reports";
import ReportsClanice from "./ReportsClanice";
import CurrentTenders from "./CurrentTenders";
import Deminimis from "./Deminimis";
import DeminimisAddPage from "./DeminimisAddPage";
import DeminimisDetailsPage from "./DeminimisDetailsPage";
import Partnerstva from "./Partnerstva";
import KontaktiUM from "./KontaktiUM";

import ProjectDetailsV2 from "./ProjectDetailsV2";
import Splosno from "./projectDetailsV2/splosno/Splosno";
import Partnerstvo from "./projectDetailsV2/partnerstvo/Partnerstvo";
import Finance from "./projectDetailsV2/finance/Finance";
import PartnerskeOrganizacije from "./projectDetailsV2/partnerstvo/partnerskeOrganizacije/PartnerskeOrganizacije";
import SodelovanjeZnotrajUM from "./projectDetailsV2/partnerstvo/sodelovanjeZnotrajUM/SodelovanjeZnotrajUM";
import NacrtovanaVrednostProjekta from "./projectDetailsV2/finance/nacrtovanaVrednostProjekta/NacrtovanaVrednostProjekta";
import RealiziranaVrednostProjekta from "./projectDetailsV2/finance/realiziranaVrednostProjekta/RealiziranaVrednostProjekta";
import StroskovnaMesta from "./projectDetailsV2/finance/stroskovnaMesta/StroskovnaMesta";
import DeminimisProjectDetails from "./projectDetailsV2/finance/deminimis/DeminimisProjectDetails";
import NotFound from "./NotFound";

/*React-bootstrap components */
import Col from "react-bootstrap/Col";

const AuthorisationComponent = ({ role }) => {
  const isAdmin = role.admin === true;

  return (
    <Col>
      <Routes>
        {/* ── General ── */}
        <AuthorizedRoute path="/" element={<Homepage role={role} />} />
        <AuthorizedRoute
          path="/DashboardBeta"
          element={<Dashboard role={role} />}
        />

        {/* ── Programs ── */}
        <AuthorizedRoute path="/Programi" element={<Programs role={role} />} />
        <AuthorizedRoute
          path="/Programi/DodajProgram/:id?"
          element={<AddProgram role={role} />}
        />
        <AuthorizedRoute
          path="/Programi/UrediProgram/:id"
          element={<EditProgram role={role} />}
        />
        <AuthorizedRoute
          path="/Programi/Struktura/:id"
          element={<ProgramStructure role={role} />}
        />

        {/* ── Tenders ── */}
        <AuthorizedRoute path="/Razpisi" element={<TendersV2 role={role} />} />
        <AuthorizedRoute
          path="/RazpisPodrobnosti/:id"
          element={<TenderDetails role={role} />}
        />
        <AuthorizedRoute
          path="/Razpisi/DodajRazpis/:id?"
          element={<AddTender role={role} />}
        />
        <AuthorizedRoute
          path="/AktualniRazpisi"
          element={<CurrentTenders role={role} />}
        />

        {/* ── Project partners ── */}
        <AuthorizedRoute
          path="/ProjektniPartnerji"
          element={<ProjectPartnersV2 role={role} />}
        />
        <AuthorizedRoute
          path="/ProjektniPartnerji/Dodaj"
          element={<AddProjectPartner role={role} />}
        />
        <AuthorizedRoute
          path="/ProjektniPartnerji/Podrobnosti/:id"
          element={<ProjectPartnerDetails role={role} />}
        />
        <AuthorizedRoute
          path="/ProjektniPartnerji/Enota/Dodaj/:id"
          element={<AddOrgUnit role={role} />}
        />
        <AuthorizedRoute
          path="/ProjektniPartnerji/Enota/Uredi/:id"
          element={<EditOrgUnit role={role} />}
        />

        {/* ── Projects ── */}
        <AuthorizedRoute
          path="/Projekti"
          element={<ProjectsV2 role={role} />}
        />
        <AuthorizedRoute
          path="/Projekti/ORUD"
          element={<ProjectsV2 role={role} />}
        />
        <AuthorizedRoute
          path="/Projekti/Clanica"
          element={<ProjectsV2 role={role} />}
        />
        <AuthorizedRoute
          path="/Projekti/DodajProjekt"
          element={<AddProject role={role} />}
        />

        {/* ── Project Details (nested routes) ── */}
        <AuthorizedRoute
          path="/Projekti/Podrobnosti/:id"
          element={<ProjectDetailsV2 role={role} />}
        >
          <AuthorizedRoute index element={<Navigate to="splosno" replace />} />
          <AuthorizedRoute path="Splosno" element={<Splosno />} />
          <AuthorizedRoute path="Partnerstvo" element={<Partnerstvo />}>
            <AuthorizedRoute
              index
              element={<Navigate to="partnerske-organizacije" replace />}
            />
            <AuthorizedRoute
              path="partnerske-organizacije"
              element={<PartnerskeOrganizacije />}
            />
            <AuthorizedRoute
              path="sodelovanje-znotraj-um"
              element={<SodelovanjeZnotrajUM />}
            />
          </AuthorizedRoute>
          <AuthorizedRoute path="Finance" element={<Finance />}>
            <AuthorizedRoute
              index
              element={<Navigate to="nacrtovana-vrednost-projekta" replace />}
            />
            <AuthorizedRoute
              path="nacrtovana-vrednost-projekta"
              element={<NacrtovanaVrednostProjekta />}
            />
            <AuthorizedRoute
              path="realizirana-vrednost-projekta"
              element={<RealiziranaVrednostProjekta />}
            />
            <AuthorizedRoute
              path="stroskovna-mesta"
              element={<StroskovnaMesta />}
            />
            <AuthorizedRoute
              path="deminimis"
              element={<DeminimisProjectDetails />}
            />
          </AuthorizedRoute>
        </AuthorizedRoute>

        {/* ── Deminimis ── */}
        <AuthorizedRoute
          path="/Deminimis"
          element={<Deminimis role={role} />}
        />
        <AuthorizedRoute
          path="/Deminimis/Skrbnistvo"
          element={<Deminimis role={role} />}
        />
        <AuthorizedRoute
          path="/Deminimis/Dodaj"
          element={<DeminimisAddPage role={role} />}
        />
        <AuthorizedRoute
          path="/Deminimis/Podrobnosti/:id"
          element={<DeminimisDetailsPage role={role} />}
        />

        {/* ── Other ── */}
        <AuthorizedRoute path="/Partnerstva" element={<Partnerstva />} />
        <AuthorizedRoute path="/KontaktiUM" element={<KontaktiUM />} />
        <AuthorizedRoute path="/izpisiClanice" element={<ReportsClanice />} />
        <AuthorizedRoute path="/Sifranti" element={<CodeList role={role} />} />

        {/* ── Admin-only routes ── */}
        {isAdmin && (
          <>
            <AuthorizedRoute
              path="/Avtorizacije"
              element={<UserRolesAuthorisation />}
            />
            <AuthorizedRoute
              path="/Avtorizacije/Dodaj"
              element={<AddUserRolesAuthorisation />}
            />
            <AuthorizedRoute
              path="/Avtorizacije/DodajFakultetnega"
              element={<AddUserFakultetaRolesAuthorisation />}
            />
            <AuthorizedRoute
              path="/Avtorizacije/uredi/:id"
              element={<EditUserRolesAuthorisation />}
            />
            <AuthorizedRoute
              path="/Avtorizacije/uredi/fakultetni/:id"
              element={<EditUserFakultetaRolesAuthorisation />}
            />
            <AuthorizedRoute
              path="/Zgodovina-sprememb"
              element={<Revision />}
            />
            <AuthorizedRoute path="/izpisi" element={<Reports />} />
          </>
        )}
        {/* ── 404 Not Found ── */}
        <AuthorizedRoute path="*" element={<NotFound />} />
      </Routes>
    </Col>
  );
};

export default AuthorisationComponent;
